import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    Output,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import {
    AbstractControl,
    FormBuilder,
    FormGroup,
    Validators,
} from '@angular/forms';
import { IExcludedCalendar } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '@services/modal.service';
import UiValidators, { UI_CALENDAR_NAME_MAX_LENGTH } from '@validators';

@Component({
    selector: 'ui-skipped-days-calendar-item',
    templateUrl: './calendar-item.component.html',
    styleUrls: [
        '../../ui-setting-form.scss',
        '../ui-skipped-days-settings.component.scss',
        './calendar-item.component.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class UiSkippedDaysCalendarItemComponent implements OnChanges, OnDestroy {

    @Input()
    public calendar!: IExcludedCalendar;

    @Input()
    public isSelected = false;

    @Output()
    public calendarSaved = new EventEmitter<IExcludedCalendar>();

    @Output()
    public focus = new EventEmitter();

    public formGroup: FormGroup;
    public formControl: AbstractControl;

    constructor(
        private _fb: FormBuilder,
        private _modalService: ModalService,
        private _translateService: TranslateService,
    ) {
        this.formGroup = this._fb.group({
            'name': [
                null,
                Validators.compose([
                    UiValidators.required(),
                    Validators.maxLength(UI_CALENDAR_NAME_MAX_LENGTH),
                ]),
            ],
        });

        this.formControl = this.formGroup.get('name')!;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.calendar) {
            const val = changes.calendar.currentValue;
            this.formControl.setValue(
                val ? val.calendarName
                    : null,
            );
        }
    }

    ngOnDestroy() {
        this.calendarSaved.complete();
    }

    public completeEdit() {
        if (this.formGroup.invalid) {
            return;
        }

        this.calendarSaved.emit(this.calendar);
    }

    public onEscape() {
        if (this.calendar.newEntry) { return; }

        this.reset();
    }

    public reset() {
        if (this.formGroup.get('name')!.value &&
            this.calendar.calendarName !== this.formGroup.get('name')!.value) {
            this._modalService.onConfirm(null,
                () => {
                    this.formGroup.get('name')!.setValue(this.calendar.calendarName);
                },
                () => { },
                this._translateService.instant('skipped_days_calendar_unsaved_changes_warning'));
        }
    }
}
